import React, { useState } from 'react';
import { Formik, Field, Form } from 'formik';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as auth from '../_redux/authRedux';
import { register } from '../_redux/authCrud';
import {
	MenuItem,
	Select,
	FormControl,
} from '@material-ui/core';

const roleSelect = ({ children, form, field }) => {
	const { name, value } = field;
	const { setFieldValue } = form;

	return (
		<Select
			name={name}
			value={value}
			style={{ padding: '1rem 1.5rem', color: 'rgb(188 188 188)' }}
			onChange={e => {
				setFieldValue(name, e.target.value);
			}}
		>
			{children}
		</Select>
	);
};

function Registration(props) {
	const { intl } = props;
	const [loading, setLoading] = useState(false);

	const enableLoading = () => setLoading(true);
	const disableLoading = () => setLoading(false);

	const getInputClasses = (meta, fieldname) => {
		let result = 'form-control form-control-solid h-auto py-5 px-6 ';
		if (meta.touched && meta.error) {
			result += ' is-invalid';
		}

		if (meta.touched && !meta.error) {
			result += ' is-valid';
		}
		return result;
	};

	return (
		<div className='login-form'>
			<div className='text-center mb-10 mb-lg-20'>
				<h3 className='font-size-h1'>
					<FormattedMessage id='AUTH.REGISTER.TITLE' />
				</h3>
				<p className='text-muted font-weight-bold'>Enter your details to create your account</p>
			</div>

			<Formik
				initialValues={{
					email: '',
					fullname: '',
					profile: 'moderation',
					password: '',
					acceptTerms: true,
					confirmPassword: '',
					merchantId: '',
				}}
				validate={(values) => {
					const errors = {};

					if (!values.email) {
						errors.email = intl.formatMessage({
							id: 'AUTH.VALIDATION.REQUIRED_FIELD',
						});
					} else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
						errors.email = intl.formatMessage({
							id: 'AUTH.VALIDATION.INVALID_FIELD',
						});
					}

					if (!values.fullname) {
						errors.fullname = intl.formatMessage({
							id: 'AUTH.VALIDATION.REQUIRED_FIELD',
						});
					}

					if (!values.profile) {
						errors.profile = intl.formatMessage({
							id: 'AUTH.VALIDATION.REQUIRED_FIELD',
						});
					}

					if (!values.password) {
						errors.password = intl.formatMessage({
							id: 'AUTH.VALIDATION.REQUIRED_FIELD',
						});
					}

					if (!values.password.match(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,15}$/)) {
						errors.password = intl.formatMessage({
							id: 'AUTH.VALIDATION.PASSWORD_RULE',
						});
					}

					if (!values.merchantId) {
						errors.merchantId = intl.formatMessage({
							id: 'AUTH.VALIDATION.REQUIRED_FIELD',
						});
					}

					if (!values.confirmPassword) {
						errors.confirmPassword = intl.formatMessage({
							id: 'AUTH.VALIDATION.REQUIRED_FIELD',
						});
					} else if (values.password !== values.confirmPassword) {
						errors.confirmPassword = "Password and Confirm Password didn't match.";
					}

					if (!values.acceptTerms) {
						errors.acceptTerms = 'Accept Terms';
					}

					return errors;
				}}
				onSubmit={(values, { setStatus, setSubmitting }) => {
					enableLoading();
					register(values.email, values.fullname, values.password, values.merchantId.toLowerCase(), values.profile)
						.then(() => {
							disableLoading();
							props.history.push('/auth/login');
						})
						.catch((err) => {
							console.error(err);
							setSubmitting(false);
							setStatus(
								intl.formatMessage({
									id: 'AUTH.VALIDATION.INVALID_SIGNUP',
								})
							);
							disableLoading();
						});
				}}
			>
				{({ values, status, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
					<Form onSubmit={handleSubmit} noValidate autoComplete='off' className='form'>
						{status && (
							<div profile='alert' className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
								<div className='alert-text font-weight-bold'>{status}</div>
							</div>
						)}

						<div className='form-group'>
							<Field type='text' name='fullname'>
								{({ field, form, meta }) => (
									<div>
										<input
											type='text'
											{...field}
											className={`${getInputClasses(meta)}`}
											placeholder='Enter Fullname'
										/>
										{meta.touched && meta.error && (
											<div className='error invalid-feedback'>{meta.error}</div>
										)}
									</div>
								)}
							</Field>
						</div>

						<div className='form-group'>
							<Field type='email' name='email'>
								{({ field, form, meta }) => (
									<div>
										<input
											type='email'
											{...field}
											className={`${getInputClasses(meta)}`}
											placeholder='Enter email'
										/>
										{meta.touched && meta.error && (
											<div className='error invalid-feedback'>{meta.error}</div>
										)}
									</div>
								)}
							</Field>
						</div>

						<div className='form-group'>
							<Field
								type='password'
								name='password'
								placeholder='Password'
								label='Password'
							>
								{({ field, form, meta }) => (
									<div>
										<input
											type='password'
											{...field}
											className={`${getInputClasses(meta)}`}
											placeholder='Enter Password'
										/>
										{meta.touched && meta.error && (
											<div className='error invalid-feedback'>{meta.error}</div>
										)}
									</div>
								)}
							</Field>
						</div>

						<div className='form-group'>
							<Field
								type='password'
								name='confirmPassword'
								placeholder='Confirm Password'
								label='Confirm Password'
							>
								{({ field, form, meta }) => (
									<div>
										<input
											type='password'
											{...field}
											className={`${getInputClasses(meta)}`}
											placeholder='Confirm Password'
										/>
										{meta.touched && meta.error && (
											<div className='error invalid-feedback'>{meta.error}</div>
										)}
									</div>
								)}
							</Field>
						</div>

						<div className='form-group'>
							<Field
								type='text'
								name='merchantId'
								placeholder='Merchant Id'
								label='Merchant Id'
							>
								{({ field, form, meta }) => (
									<div>
										<input
											type='text'
											{...field}
											className={`${getInputClasses(meta)}`}
											placeholder='Merchant Id'
										/>
										{meta.touched && meta.error && (
											<div className='error invalid-feedback'>{meta.error}</div>
										)}
									</div>
								)}
							</Field>
						</div>

						<div className='form-group' style={{ backgroundColor: '#f3f6f9', borderRadius: '5px' }}>
							<FormControl style={{ width: '-webkit-fill-available' }}>
								<Field name="profile" component={roleSelect}>
									<MenuItem value={'moderation'}>Moderation</MenuItem>
									<MenuItem value={'admin'}>Admin</MenuItem>
								</Field>
							</FormControl>
						</div>

						<div className='form-group'>
							<label className='checkbox'>
								<input type='checkbox' name='acceptTerms' />I agree the{' '}
								<a href='https://www.squadded.co/terms-policy' target='_blank' rel='noopener noreferrer'>
									Terms of Use&nbsp;
								</a>
								accept the Subscription plan
								<span />
							</label>
						</div>

						<div className='form-group d-flex flex-wrap flex-center'>
							<button
								type='submit'
								disabled={isSubmitting || !values.acceptTerms}
								className='btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4'
							>
								<span>Submit</span>
								{loading && <span className='ml-3 spinner spinner-white'></span>}
							</button>

							<Link to='/auth/login'>
								<button
									type='button'
									className='btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4'
								>
									Cancel
								</button>
							</Link>
						</div>
					</Form>
				)}
			</Formik>
		</div>
	);
}

export default injectIntl(connect(null, auth.actions)(Registration));
